"use client";

export default function ScopeOfServices() {
  return (
    <>
      <style>{`
    body { font-family: 'Segoe UI', Arial, sans-serif; background: #f4faf4; color: #1a3c1a; }

    /* ── HERO ── */
    .hero {
      background: linear-gradient(120deg, #1b5e20 0%, #2e7d32 50%, #43a047 100%);
      padding: 64px 48px 56px;
      text-align: center;
      color: #fff;
      position: relative;
      overflow: hidden;
    }
    .hero::before {
      content: '';
      position: absolute; top: -60px; right: -60px;
      width: 280px; height: 280px;
      background: rgba(255,255,255,0.05);
      border-radius: 50%;
    }
    .hero::after {
      content: '';
      position: absolute; bottom: -80px; left: -40px;
      width: 220px; height: 220px;
      background: rgba(255,255,255,0.04);
      border-radius: 50%;
    }
    .hero-badge {
      display: inline-block;
      background: rgba(255,255,255,0.15);
      border: 1px solid rgba(255,255,255,0.3);
      padding: 5px 18px;
      border-radius: 20px;
      font-size: 0.8rem;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      margin-bottom: 16px;
    }
    .hero h2 { font-size: 2.6rem; font-weight: 700; margin-bottom: 14px; line-height: 1.2; }
    .hero p { font-size: 1.05rem; opacity: 0.88; max-width: 640px; margin: 0 auto 28px; }
    .hero-btn {
      display: inline-block;
      background: #fff;
      color: #1b5e20;
      padding: 13px 34px;
      border-radius: 30px;
      font-weight: 700;
      font-size: 0.95rem;
      text-decoration: none;
      box-shadow: 0 4px 18px rgba(0,0,0,0.18);
      transition: transform 0.2s, box-shadow 0.2s;
      margin: 0 8px;
    }
    .hero-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 24px rgba(0,0,0,0.22); }
    .hero-btn.outline {
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
    }
    .hero-btn.outline:hover { background: rgba(255,255,255,0.1); }

    /* ── STATS BAR ── */
    .stats-bar {
      background: #fff;
      border-bottom: 3px solid #e8f5e9;
      display: flex;
      justify-content: center;
      gap: 0;
    }
    .stat-item {
      text-align: center;
      padding: 22px 48px;
      border-right: 1px solid #e8f5e9;
    }
    .stat-item:last-child { border-right: none; }
    .stat-num { font-size: 2rem; font-weight: 800; color: #2e7d32; }
    .stat-label { font-size: 0.8rem; color: #555; text-transform: uppercase; letter-spacing: 0.5px; margin-top: 2px; }

    /* ── SECTION TITLE ── */
    .section { padding: 56px 48px; }
    .section-title {
      text-align: center;
      margin-bottom: 40px;
    }
    .section-title h3 {
      font-size: 1.9rem;
      font-weight: 700;
      color: #1b5e20;
      margin-bottom: 8px;
    }
    .section-title p { color: #555; font-size: 0.97rem; }
    .green-line {
      width: 60px; height: 4px;
      background: linear-gradient(90deg, #2e7d32, #66bb6a);
      border-radius: 2px;
      margin: 10px auto 0;
    }

    /* ── CLINICAL SPECIALTIES GRID ── */
    .specialties-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 14px;
    }
    .specialty-card {
      background: #fff;
      border: 1px solid #c8e6c9;
      border-left: 4px solid #2e7d32;
      border-radius: 8px;
      padding: 14px 16px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #1a3c1a;
      transition: box-shadow 0.2s, transform 0.2s, border-left-color 0.2s;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .specialty-card:hover {
      box-shadow: 0 4px 16px rgba(46,125,50,0.15);
      transform: translateY(-2px);
      border-left-color: #43a047;
    }
    .specialty-card .icon { font-size: 1.3rem; flex-shrink: 0; }

    /* ── THREE COLUMN SERVICES ── */
    .three-col { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 28px; }
    .service-box {
      background: #fff;
      border-radius: 12px;
      border: 1px solid #c8e6c9;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    }
    .service-box-header {
      background: linear-gradient(135deg, #2e7d32, #388e3c);
      color: #fff;
      padding: 16px 20px;
      font-size: 1rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .service-box ul { list-style: none; padding: 16px 20px; }
    .service-box ul li {
      padding: 7px 0;
      border-bottom: 1px solid #f1f8f1;
      font-size: 0.88rem;
      color: #2d4a2d;
      display: flex;
      align-items: flex-start;
      gap: 8px;
    }
    .service-box ul li:last-child { border-bottom: none; }
    .service-box ul li::before { content: "✓"; color: #2e7d32; font-weight: 700; flex-shrink: 0; }

    /* ── NOT AVAILABLE ── */
    .not-available {
      background: #fff;
      border: 1px solid #ffcdd2;
      border-left: 4px solid #e53935;
      border-radius: 8px;
      padding: 14px 16px;
      font-size: 0.88rem;
      display: flex;
      align-items: center;
      gap: 10px;
      color: #b71c1c;
    }
    .not-avail-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 12px; }
    .not-available::before { content: "✗"; font-weight: 700; flex-shrink: 0; }

    /* ── CTA ── */
    .cta-section {
      background: linear-gradient(135deg, #1b5e20, #2e7d32);
      color: #fff;
      text-align: center;
      padding: 56px 48px;
    }
    .cta-section h3 { font-size: 2rem; font-weight: 700; margin-bottom: 12px; }
    .cta-section p { opacity: 0.88; margin-bottom: 28px; font-size: 1rem; }
    .cta-btn {
      display: inline-block;
      background: #fff;
      color: #1b5e20;
      padding: 14px 38px;
      border-radius: 30px;
      font-weight: 700;
      font-size: 1rem;
      text-decoration: none;
      margin: 0 8px;
      box-shadow: 0 4px 18px rgba(0,0,0,0.2);
      transition: transform 0.2s;
    }
    .cta-btn:hover { transform: translateY(-2px); }

    /* ── RESPONSIVE ── */
    @media(max-width: 900px) {
      .hero { padding: 40px 20px; }
      .hero h2 { font-size: 1.8rem; }
      .stats-bar { flex-wrap: wrap; }
      .stat-item { padding: 16px 24px; }
      .section { padding: 36px 20px; }
      .three-col { grid-template-columns: 1fr; }
      .specialties-grid { grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); }
    }
      `}</style>

      <div
        dangerouslySetInnerHTML={{
          __html: `
            <!-- HERO -->
<div class="hero">
  <div class="hero-badge">Tertiary Care · Multispecialty</div>
  <h2>Comprehensive Scope of Services</h2>
  <p>Delivering excellence in healthcare across 40+ clinical specialties with advanced critical care, diagnostics, and patient-centric support services.</p>
  <a href="#specialties" class="hero-btn">Explore Services</a>
  <a href="#contact" class="hero-btn outline">Book Appointment</a>
</div>

<!-- STATS BAR -->
<div class="stats-bar">
  <div class="stat-item"><div class="stat-num">40+</div><div class="stat-label">Clinical Specialties</div></div>
  <div class="stat-item"><div class="stat-num">200+</div><div class="stat-label">Beds</div></div>
  <div class="stat-item"><div class="stat-num">3</div><div class="stat-label">Specialised ICUs</div></div>
  <div class="stat-item"><div class="stat-num">1981</div><div class="stat-label">Established</div></div>
  <div class="stat-item"><div class="stat-num">24×7</div><div class="stat-label">Emergency Care</div></div>
</div>

<!-- CLINICAL SPECIALTIES -->
<div class="section" id="specialties" style="background:#f4faf4;">
  <div class="section-title">
    <h3>Clinical Specialties</h3>
    <p>Our multidisciplinary team of experts covers a wide range of medical and surgical specialties.</p>
    <div class="green-line"></div>
  </div>
  <div class="specialties-grid">
    <div class="specialty-card"><span class="icon">🚑</span> Accident &amp; Emergency Services</div>
    <div class="specialty-card"><span class="icon">💉</span> Anesthesiology</div>
    <div class="specialty-card"><span class="icon">⚖️</span> Bariatric &amp; Metabolic Surgery</div>
    <div class="specialty-card"><span class="icon">🩸</span> Bone Marrow Transplant</div>
    <div class="specialty-card"><span class="icon">❤️</span> Cardiology / Interventional Cardiology</div>
    <div class="specialty-card"><span class="icon">🫀</span> Cardiothoracic Surgery</div>
    <div class="specialty-card"><span class="icon">🦷</span> Dentistry (Outsourced)</div>
    <div class="specialty-card"><span class="icon">🌿</span> Dermatology</div>
    <div class="specialty-card"><span class="icon">🍬</span> Diabetology &amp; Diabetic Surgery</div>
    <div class="specialty-card"><span class="icon">🥗</span> Dietetics</div>
    <div class="specialty-card"><span class="icon">🔬</span> Endocrinology</div>
    <div class="specialty-card"><span class="icon">🔪</span> Endocrine Surgery</div>
    <div class="specialty-card"><span class="icon">👂</span> ENT</div>
    <div class="specialty-card"><span class="icon">🫁</span> Gastroenterology – Hepatobiliary Medicine</div>
    <div class="specialty-card"><span class="icon">🔧</span> Gastroenterology Surgery</div>
    <div class="specialty-card"><span class="icon">🫓</span> Hepato-Pancreatic Biliary Surgery</div>
    <div class="specialty-card"><span class="icon">🩺</span> General Medicine</div>
    <div class="specialty-card"><span class="icon">🏥</span> General Surgery</div>
    <div class="specialty-card"><span class="icon">🧬</span> Hematology</div>
    <div class="specialty-card"><span class="icon">🦠</span> Infectious Diseases</div>
    <div class="specialty-card"><span class="icon">📡</span> Interventional Radiology</div>
    <div class="specialty-card"><span class="icon">🔩</span> Minimal Access Surgery</div>
    <div class="specialty-card"><span class="icon">🦷</span> Maxillofacial Surgery</div>
    <div class="specialty-card"><span class="icon">👶</span> Neonatology</div>
    <div class="specialty-card"><span class="icon">🫘</span> Nephrology</div>
    <div class="specialty-card"><span class="icon">💧</span> Dialysis (AKD)</div>
    <div class="specialty-card"><span class="icon">🫘</span> Kidney Transplant Surgery</div>
    <div class="specialty-card"><span class="icon">🫀</span> Liver Transplant Surgery</div>
    <div class="specialty-card"><span class="icon">☢️</span> Nuclear Medicine</div>
    <div class="specialty-card"><span class="icon">🧠</span> Neurology &amp; Interventional Neurology</div>
    <div class="specialty-card"><span class="icon">🧠</span> Neurosurgery</div>
    <div class="specialty-card"><span class="icon">🤰</span> Obstetrics &amp; Gynecology (incl. High Risk)</div>
    <div class="specialty-card"><span class="icon">🎗️</span> Oncology – Medical &amp; Surgical</div>
    <div class="specialty-card"><span class="icon">👁️</span> Ophthalmology</div>
    <div class="specialty-card"><span class="icon">🦴</span> Orthopedics &amp; Joint Replacement</div>
    <div class="specialty-card"><span class="icon">👧</span> Pediatrics</div>
    <div class="specialty-card"><span class="icon">👶</span> Pediatric Surgery</div>
    <div class="specialty-card"><span class="icon">🦴</span> Pediatric Orthopedics</div>
    <div class="specialty-card"><span class="icon">😣</span> Pain Management &amp; Anesthesia</div>
    <div class="specialty-card"><span class="icon">✂️</span> Plastic &amp; Reconstructive Surgery</div>
    <div class="specialty-card"><span class="icon">🩸</span> Peripheral Vascular Surgery</div>
    <div class="specialty-card"><span class="icon">🫁</span> Pulmonology</div>
    <div class="specialty-card"><span class="icon">🧘</span> Physiotherapy &amp; Occupational Therapy</div>
    <div class="specialty-card"><span class="icon">🧠</span> Psychiatry (OP Only)</div>
    <div class="specialty-card"><span class="icon">💬</span> Psychology</div>
    <div class="specialty-card"><span class="icon">🦴</span> Rheumatology</div>
    <div class="specialty-card"><span class="icon">🦴</span> Spine Surgery</div>
    <div class="specialty-card"><span class="icon">🩸</span> Transfusion Medicine</div>
    <div class="specialty-card"><span class="icon">🫘</span> Urology &amp; Andrology</div>
  </div>
</div>

<!-- SUPPORT & DIAGNOSTIC SERVICES -->
<div class="section" id="support" style="background:#fff;">
  <div class="section-title">
    <h3>Support &amp; Diagnostic Services</h3>
    <p>Comprehensive infrastructure and diagnostics enabling seamless, high-quality patient care.</p>
    <div class="green-line"></div>
  </div>
  <div class="three-col">

    <!-- Critical Care -->
    <div class="service-box">
      <div class="service-box-header">🛏️ Critical Care Units</div>
      <ul>
        <li>ICU (Intensive Care Unit)</li>
        <li>Pediatrics ICU</li>
        <li>Neonatal ICU</li>
      </ul>
    </div>

    <!-- Support Services -->
    <div class="service-box">
      <div class="service-box-header">⚙️ Support Services</div>
      <ul>
        <li>Pharmacy</li>
        <li>CSSD</li>
        <li>F&amp;B &amp; Dietary Services (Outsourced)</li>
        <li>Housekeeping &amp; Facility Management</li>
        <li>Laundry Services (Outsourced)</li>
        <li>Engineering &amp; Maintenance</li>
        <li>Bio-Medical Engineering</li>
        <li>Human Resources</li>
        <li>Security Services (Outsourced)</li>
        <li>Medical Records</li>
        <li>Patient Experience</li>
        <li>Purchase &amp; Stores</li>
        <li>Information Technology</li>
        <li>Accounts &amp; Finance</li>
        <li>Sales &amp; Marketing</li>
        <li>Blood Bank</li>
        <li>Ambulance Services</li>
      </ul>
    </div>

    <!-- Diagnostic Services -->
    <div class="service-box" id="diagnostics">
      <div class="service-box-header">🔬 Diagnostic Services</div>
      <ul>
        <li>Laboratory Medicine</li>
        <li>Biochemistry</li>
        <li>Hematology</li>
        <li>Microbiology</li>
        <li>Histopathology &amp; Cytology</li>
        <li>Non-Invasive Cardiology (ECG, 2D Echo, Stress Test, Holter)</li>
        <li>PET Scan</li>
        <li>Audiometry &amp; Speech Therapy</li>
        <li>Pulmonary Function Test</li>
        <li>Radiology &amp; Imaging (X-ray, CT, MRI, USG, Mammography)</li>
        <li>Neurodiagnostic (EEG, EMG, NCV)</li>
        <li>Uro Dynamic Study</li>
      </ul>
    </div>

  </div>
</div>

<!-- SERVICES NOT AVAILABLE -->
<div class="section" style="background:#fff8f8; padding-top:0;">
  <div class="section-title">
    <h3 style="color:#c62828;">Services Not Available</h3>
    <p>The following services are currently not offered at S.L. Raheja Hospital.</p>
    <div class="green-line" style="background:linear-gradient(90deg,#e53935,#ef9a9a);"></div>
  </div>
  <div class="not-avail-grid">
    <div class="not-available">Radiation Oncology</div>
    <div class="not-available">Care of Deep Burns</div>
    <div class="not-available">Inpatient Services for Psychiatric Patients</div>
  </div>
</div>

<!-- CTA -->
<div class="cta-section" id="contact">
  <h3>Experience World-Class Healthcare</h3>
  <p>Book an appointment with our specialist doctors or reach out to our 24×7 helpline.</p>
  <a href="tel:022-68846141" class="cta-btn">📞 Call Us Now</a>
  <a href="https://rahejahospital.com" target="_blank" class="cta-btn">🌐 Visit Website</a>
</div>
          `,
        }}
      />
    </>
  );
}